/*
  * Copyright Amazon.com, Inc. and its affiliates. All Rights Reserved.
  * SPDX-License-Identifier: MIT
  *
  * Licensed under the MIT License. See the LICENSE accompanying this file
  * for the specific language governing permissions and limitations under
  * the License.
  */

import axios from 'axios';
import jwt_decode from 'jwt-decode';
import { setCookie } from './cookieHelper';
import awsconfig from '../../src/aws-exports';
import { DIContainer } from '../../packages/idn-media-framework-tsyringe/DIContainer';
import { ILogger } from '../../packages/idn-media-framework-abstraction/ILogger';

export async function storeTokens(authorization_code: string, idToken: string, accessToken: string, refreshToken: string) {

	const logger = DIContainer.Resolve<ILogger>('ILogger');
	// return ({
	// 	status:200,
	// 	data: ''
	// });

	logger.debug('Storing tokens to /storage...')
	/*
	 * Call storage endpoint to store tokens in DynamoDB
	 */
	var response = await axios.post(
		`${awsconfig.aws_cloud_logic_custom[0].endpoint}storage`,
		{
			authorization_code: authorization_code,
			id_token: idToken,
			access_token: accessToken,
			refresh_token: refreshToken
		},
		{ headers: { 'Content-Type': 'application/json' } }
	)

	logger.debug('Storing tokens to /storage...[DONE]');

	return response;
}

export function setTokenCookie(type: string, token: string) {
	const logger = DIContainer.Resolve<ILogger>('ILogger');
	
	logger.debug('Storing token to cookie bycalling setTokenCookie...');

	let tokenDecoded:any = jwt_decode(token);
	let tokenExpiry = tokenDecoded['exp'];
	setCookie(type, token, tokenExpiry);

	logger.debug('Storing token to cookie bycalling setTokenCookie...[DONE]');
}

export function setRefreshTokenCookie(refreshToken: string, accessToken: string) { // Use expiry of access token to set the refresh token cookie
	const logger = DIContainer.Resolve<ILogger>('ILogger');

	logger.debug('Storing token to cookie bycalling setRefreshTokenCookie...');

	let tokenDecoded:any = jwt_decode(accessToken);
	let tokenExpiry = tokenDecoded['exp'];
	setCookie("refresh_token", refreshToken, tokenExpiry);

	logger.debug('Storing token to cookie bycalling setRefreshTokenCookie...[DONE]');
}
